module.exports = __webpack_public_path__ + "static/media/WindowReplacement.98e67d09.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/pdf/WindowReplacement.pdf
// module id = 354
// module chunks = 0